document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('designer-search');
  const designerLinks = document.querySelectorAll('.designer-link');
  const letterSections = document.querySelectorAll('.letter-section');
  const noResults = document.getElementById('no-results');
  const designersContent = document.querySelector('.designers-content');

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase().trim();
      let visibleCount = 0;

      designerLinks.forEach(function(link) {
        const designerName = link.getAttribute('data-designer') || "";

        if (designerName.includes(searchTerm)) {
          link.style.display = 'block';
          visibleCount++;
        } else {
          link.style.display = 'none';
        }
      });

      letterSections.forEach(function(section) {
        const visibleItems = section.querySelectorAll('.designer-link:not([style*="display: none"])');
        section.style.display = visibleItems.length ? 'block' : 'none';
      });

      if (visibleCount === 0) {
        noResults.style.display = 'block';
        designersContent.style.display = 'none';
      } else {
        noResults.style.display = 'none';
        designersContent.style.display = 'block';
      }
    });
  }

  document.querySelectorAll('.letter-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

});
